import type { DashboardUser, DashboardUserInvite } from "@xop/dashboard-shared";

/**
 * Combined row union used by the paginated table. Invites render
 * first (visually distinct, "pending sign-in") followed by active
 * users — same order the panel had pre-pagination. The discriminated
 * union lets `<Row>` pick the right component without a downcast.
 */
export type CombinedRow =
  | { kind: "invite"; invite: DashboardUserInvite }
  | { kind: "user"; user: DashboardUser };

/** Human-readable client/version label from the stored `client_version`
 * ("0.1.23" → "v0.1.23", "web" → "Web", "desktop" → "Desktop", null → "—"). */
export function formatClient(v: string | null): { label: string; title: string } {
  if (!v) return { label: "—", title: "No client recorded yet — they haven't signed in since this shipped" };
  if (v === "web") return { label: "Web", title: "Signed in via the web browser" };
  if (v === "desktop") return { label: "Desktop", title: "Desktop app (version not reported)" };
  return { label: `v${v}`, title: `XOP Command Center desktop app v${v}` };
}
